import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './index.scss';
import Loading from '../common/Loading';

class ServiceAgent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedLocationId: null,
      isDownloading: false,
    };
  }

  toggleLocationExpansion = (locationId) => {
    this.setState((prevState) => ({
      expandedLocationId: prevState.expandedLocationId === locationId ? null : locationId,
    }));
  };

  getServicesForLocation = (studioId) => {
    const { business } = this.props;
    const servicesById = business?.serviceById || {};

    return Object.values(servicesById).filter((service) => {
      const serviceIdParts = service.id.split('-');
      if (serviceIdParts.length >= 2) {
        const serviceStudioId = serviceIdParts[1];
        return serviceStudioId === studioId;
      }
      return false;
    });
  };

  formatDuration = (duration) => {
    if (!duration) return 'N/A';
    if (duration.startsWith('PT')) {
      const hours = duration.match(/(\d+)H/);
      const minutes = duration.match(/(\d+)M/);
      
      const h = hours ? parseInt(hours[1]) : 0;
      const m = minutes ? parseInt(minutes[1]) : 0;
      
      if (h > 0 && m > 0) {
        return `${h} hour ${m} mins`;
      } else if (h > 0) {
        return h === 1 ? '1 hour' : `${h} hours`;
      } else if (m >= 0) {
        return `${m} mins`;
      }
    }
    return duration;
  };

  renderServiceItem = (service) => {
    const duration = this.formatDuration(service.duration || service.total_duration);
    
    return (
      <div key={service.id} className="service-item">
        <div className="service-info">
          <div className="service-title">
            {service.name} (ID: {service.id})
            <div className="service-description">
                {service.description}
            </div>
          </div>
          {duration !== 'N/A' && (
            <div className="service-duration-badge">
              <span className="material-icons">schedule</span>
              {duration}
            </div>
          )}
        </div>
      </div>
    );
  };

  renderLocationCard = (location, index, locations_length) => {
    const locationName = location.studioName || location.businessName || location.business_name || location.name || '';
    const address = location.studioAddress || location.address || '';
    const isExpanded = this.state.expandedLocationId === location.studioId;
    const services = this.getServicesForLocation(location.studioId);
    const { isDownloading } = this.state;
    
    return (
      <div key={location.studioId} className={`location-card ${isExpanded ? 'expanded' : ''}`}>
        <div className="location-header-section">
          <div className="location-info">
            <div className="location-header">
              <h3 className="location-title">{locations_length > 1 ? `${index + 1}. ` : ''} {locationName} ({location.studioId})</h3>
            </div>
            <div className="location-address">{address}</div>
          </div>
          <div className="location-actions">
            <button 
              className={`btn download-btn ${isDownloading ? 'downloading' : ''}`}
              onClick={() => this.downloadServices(location.studioId)}
              disabled={isDownloading}
            >
              <span className="material-icons download-icon">download</span>
              {isDownloading ? 'Downloading...' : 'Download Services'}
            </button>
            <button 
              className={`dropdown-btn ${isExpanded ? 'expanded' : ''}`}
              onClick={() => this.toggleLocationExpansion(location.studioId)}
            >
              <span className="material-icons expand_less">expand_more</span>
            </button>
          </div>
        </div>
        
        {isExpanded && (
          <div className="services-section">
            <div className="services-container">
              {services.length > 0 ? (
                services.map((service, serviceIndex) => 
                  this.renderServiceItem(service, serviceIndex)
                )
              ) : (
                <div className="no-services">
                  <p>No services available for this location</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  downloadServices = (locationId) => {
    const file = window.Config.API_URL + `/livedashboard/business/${locationId}/all_services`;
    window.open(file);
  };
  
  render() {
    const { business } = this.props;
    const locations =
      (business?.locations && business.locations.length > 0
        ? business.locations
        : (business?.details?.locations || []).map(loc => ({
          ...loc,
          studioId: loc.id?.split("-")[1] || null,
        }))
      ) || [];
    const validStudioIds = (business?.details?.locations || []).map(
      item => item.id?.split("-")[1]
    );
    return (
      <div className="service-agent">
        <div className="service-agent-container">
          <div className="service-agent-header">
            <div className="title">
              <span>Service Agent</span>
              {business?.details?.name && (
                <>
                  <span className="business_details">
                    {business?.details?.name}({business?.details?.data?.id})
                  </span>
                </>
              )}
            </div>
          </div>
          {locations.length > 0 ? (
            <div className="service-agent-content">
              <div className="content-container">
                <div className="locations-list">
                  {(() => {
                    const filteredLocations = locations.filter(location =>
                      validStudioIds.includes(location.studioId)
                    );
                    return filteredLocations.map((location, index) =>
                      this.renderLocationCard(location, index, filteredLocations.length)
                    );
                  })()}
                </div>
              </div>
            </div>
          ) : (
            <div className="full-page-loader">
              <Loading />
              <p>Loading locations...</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}
  
ServiceAgent.propTypes = {
  business: PropTypes.object,
  serviceAgent: PropTypes.object,
};
  
const mapStateToProps = (state) => ({
});
  
export default connect(mapStateToProps, {
})(ServiceAgent);